/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

import {
  classNameForIconButtonIconProps,
  classNameForIconButtonProps,
} from '../../utils/iconButtonUtils';
import Button, { IButton } from './DeprecatedButton';

export interface IIconButton extends IButton {
  className?: string;
  disabled?: boolean;
  iconSize?: 'medium' | 'large';
  id?: string;
  modifierClassName?: string;
  stretch?: boolean;
  text: string;
  hideText?: boolean;
  onPointerDown?(event: React.PointerEvent<HTMLElement>): void;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
  onKeyPress?(event: React.KeyboardEvent): void;
  children?: React.ReactNode;
  tabIndex?: number;
}

export interface Props extends IIconButton {
  IconComponent?(props: any): JSX.Element;
}

/**
 * @deprecated Succeeded by ui/IconButton (dashboard) and bamboo/IconButton (consumer)
 * @see http://tock-assets.tocktix.com/styleguide/dashboard/index.html?path=/story/components-iconbutton--colors-and-variants
 * @see http://tock-assets.tocktix.com/styleguide/consumer/index.html?path=/story/bamboo-button-iconbutton--base
 */
const IconButton: React.FunctionComponent<React.PropsWithChildren<Props>> = (props) => {
  const { children, IconComponent, text, hideText, modifierClassName, iconSize, ...rest } = props;
  const iconClassName = classNameForIconButtonIconProps(props);
  return (
    <Button
      title={text}
      aria-label={text}
      {...rest}
      modifierClassName={classNameForIconButtonProps(props)}
    >
      {IconComponent && <IconComponent className={iconClassName} />}
      {!hideText && <span className="IconButton-text">{text}</span>}
      {children}
    </Button>
  );
};

export default IconButton;
